import SymfonyFrame from '@components/layouts/symfony-frame';
import { store } from '@store';

export const privacyBanners = {
  path: 'privacy-banners/:bannerID/',
  name: 'privacy-banners-banners',
  meta: {
    breadcrumb: null,
  },
  async beforeEnter(to, from, next) {
    await store.dispatch('privacy/privacyBanners/findAll');

    store.commit('privacy/privacyBanners/_switchCurrentEntityById', to.params.bannerID);
    next();
  },
  children: [
    {
      path: 'edition/',
      name: 'privacy-banners-edition',
      component: SymfonyFrame,
      meta: {
        symfonyPath: to => {
          return `/containers/privacy/settings/${to.params.bannerID}/consent-exports-default-banner`;
        },
      },
    },
    {
      path: 'deploy/',
      name: 'privacy-banners-deploy',
      component: SymfonyFrame,
      meta: {
        symfonyPath: to => {
          return `/containers/privacy/deploy/${to.params.bannerID}/consent-exports-default-banner`;
        },
      },
    },
    {
      path: 'consent-analysis',
      name: 'consent-dashboard-privacy-banners',
      meta: {
        symfonyPath: '/containers/privacy/dashboard',
      },
      component: SymfonyFrame,
    },
    {
      path: 'cookie-scanner/',
      name: 'privacy-banners-cookie-scanner',
      meta: {
        authorization: [{ siteParametersAccess: 'trust_crawler' }],
      },
      component: () => import('@views/trust/cookie-scanner/cookie-scanner-edit.vue'),
    },
    {
      path: 'piggybacking/',
      name: 'privacy-banners-piggybacking',
      component: SymfonyFrame,
      meta: {
        symfonyPath: '/containers/tagperf/tags-hierarchy',
      },
    },
    {
      path: 'consent-categories/',
      name: 'privacy-banners-consent-categories',
      component: SymfonyFrame,
      meta: {
        symfonyPath: '/containers/privacy/categories',
        can: 'view.TrustCategories',
      },
    },
    {
      path: 'consent-settings/',
      name: 'privacy-banners-consent-settings',
      component: SymfonyFrame,
      meta: {
        symfonyPath: '/containers/privacy/options',
        can: 'edit.TrustOptions',
      },
    },
    {
      path: 'vendor-settings/',
      name: 'privacy-banners-vendor-settings',
      component: SymfonyFrame,
      meta: {
        symfonyPath: '/containers/privacy/vendors',
        can: 'view.TrustCategories',
      },
    },
    {
      path: 'tag-assignation/',
      name: 'privacy-banners-tag-assignation',
      component: SymfonyFrame,
      meta: {
        symfonyPath: '/containers/privacy/tags',
        can: 'edit.TmsContainer',
      },
    },
  ],
};
